/* eslint-disable react/no-array-index-key */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import styles from '../../../../styles/guest/partials/menu.module.scss';

const propTypes = {
    currentIndex: PropTypes.number,
    count: PropTypes.number,
    dark: PropTypes.bool,
    onItemClick: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    currentIndex: false,
    count: 0,
    dark: false,
    onItemClick: null,
    className: null,
};

const Menu = ({ currentIndex, count, dark, onItemClick, className }) => {
    const onDotClick = useCallback(
        (index) => {
            if (onItemClick !== null) {
                onItemClick(index);
            }
        },
        [onItemClick],
    );
    return (
        <nav
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.dark]: dark,
                },
            ])}
        >
            <ul>
                {[...Array(count)].map((section, sectionIndex) => (
                    <li key={`section-${sectionIndex}`}>
                        <button
                            className={classNames([
                                styles.button,
                                { [styles.active]: sectionIndex === currentIndex },
                            ])}
                            type="button"
                            aria-label={`Section ${sectionIndex}`}
                            onClick={() => {
                                onDotClick(sectionIndex);
                            }}
                        >
                            <span className={styles.dot} />
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;

export default Menu;
